import { ReactElement } from 'react';

export enum InAppLayoutVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

export enum TopBarVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type TopBarProps = {
  title?: string;
  variant?: InAppLayoutVariant;
  customOnBackClick?: () => void;

  // Primary only
  hasSearch?: boolean;
  hasBackButton?: boolean;
  topBarVariant?: TopBarVariant;

  // Secondary only
  hasShareButton?: boolean;
  hasLikeButton?: boolean;
  handleLikeChange?: () => void;
  isLiked?: boolean | null;
  hasReadButton?: boolean;
  handleReadChange?: () => void;
  isRead?: boolean | null;
  shareData?: ShareData;

  // Worksheet editor only
  worksheetEditorOptions?: {
    isViewMode: boolean;
    title: string;
    ButtonComponents: ReactElement;
  };

  // Worksheet session only
  worksheetSessionOptions?: {
    title: string;
    ButtonComponents: ReactElement;
  };
};

export type TopBarContextProps = {
  currentTopBarValues: TopBarProps;
  setCurrentTopBarValues: (value: TopBarProps) => void;
  defaultTopBarValues: TopBarProps;
};

export type MetaProps = {
  headTitle?: string;
};

export type MetaContextProps = {
  currentMetaDataValues: MetaProps;
  setCurrentMetaDataValues: (value: MetaProps) => void;
  defaultMetaDataValues: MetaProps;
};
